(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}__webpack_unused_export__=l;exports.jsx=q;__webpack_unused_export__=q;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 81301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","i":"src-components-Icon-styles_i","smallIcon":"src-components-Icon-styles_smallIcon","disabled":"src-components-Icon-styles_disabled","greyIcon":"src-components-Icon-styles_greyIcon"});

/***/ }),

/***/ 87083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_BaseIcon)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/styles.scss
var styles = __webpack_require__(81301);
;// ./src/components/Icon/BaseIcon/BaseIcon.tsx
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIcon(_a) {
    var { icon, src, className, isDisabled = false, onClick = () => null, onMouseEnter = () => null, onMouseLeave = () => null, isSmall = false, isGrey = false, style } = _a, restProps = __rest(_a, ["icon", "src", "className", "isDisabled", "onClick", "onMouseEnter", "onMouseLeave", "isSmall", "isGrey", "style"]);
    const [iconHtml, setIconHtml] = (0,external_react_.useState)(null);
    const isMounted = (0,external_react_.useRef)(false);
    (0,external_react_.useEffect)(() => {
        const controller = new AbortController();
        isMounted.current = true;
        getIconHtml(controller);
        return () => {
            isMounted.current = false;
            controller === null || controller === void 0 ? void 0 : controller.abort();
        };
    }, [icon, src]);
    const getIconHtml = (controller) => __awaiter(this, void 0, void 0, function* () {
        if (src) {
            let iconResponse = yield fetch(src, {
                signal: controller.signal,
            });
            // @ts-ignore
            setIconHtml(yield iconResponse.text());
            // @ts-ignore
            controller = null;
            return;
        }
        let iconHtml = null;
        if (icon) {
            iconHtml = icon;
        }
        // @ts-ignore
        isMounted.current && setIconHtml(iconHtml);
    });
    return ((0,jsx_runtime.jsx)("i", { "data-test": restProps['data-test'], className: classnames_default()(styles/* default */.A.i, className, {
            [styles/* default */.A.disabled]: isDisabled,
            [styles/* default */.A.smallIcon]: isSmall,
            [styles/* default */.A.greyIcon]: isGrey,
        }), 
        // @ts-ignore
        dangerouslySetInnerHTML: { __html: iconHtml }, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }));
}
/* harmony default export */ const BaseIcon_BaseIcon = (BaseIcon);

;// ./src/components/Icon/BaseIcon/index.ts

/* harmony default export */ const Icon_BaseIcon = (BaseIcon_BaseIcon);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_IconZeroAppliedRedactions)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/components/Icon/BaseIcon/index.ts + 1 modules
var BaseIcon = __webpack_require__(87083);
;// ./src/components/Icon/IconZeroAppliedRedactions/zero-applied-redactions.inline.svg?raw
/* harmony default export */ const zero_applied_redactions_inlineraw = ("<svg width=\"16\" height=\"16\" viewBox=\"0 0 74 49\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.27237 47.2074H39.7986V37.971H2.27237V47.2074ZM41.5764 49V36.1784H0.494594V49H41.5764Z\" />\n<path d=\"M26.9593 9.7366C25.1546 9.7366 24.3504 8.14811 23.8185 7.09685C23.6441 6.75278 23.3621 6.19565 23.1771 6.0232C22.9921 6.19565 22.7101 6.75278 22.5358 7.09685C22.0046 8.14811 21.1997 9.7366 19.3949 9.7366C17.591 9.7366 16.7868 8.14811 16.2557 7.09685C16.0814 6.75278 15.8002 6.1973 15.6152 6.0232C15.4302 6.1973 15.1498 6.75278 14.9755 7.09685C14.4435 8.14811 13.6394 9.7366 11.8346 9.7366C10.0307 9.7366 9.22655 8.14811 8.6954 7.09602C8.52191 6.75278 8.23989 6.19813 8.05571 6.02403C7.86989 6.19813 7.59034 6.75278 7.41685 7.09602C6.88487 8.14811 6.08157 9.7366 4.2768 9.7366C2.47285 9.7366 1.66954 8.14811 1.13757 7.09602C0.94846 6.72128 0.631083 6.0945 0.450195 5.98589C0.461706 5.99252 0.486373 5.99999 0.499528 6.00081L0.498706 3.17037C2.30265 3.17037 3.1076 4.7597 3.63876 5.81096C3.81225 6.15419 4.09262 6.70884 4.2768 6.88295C4.46262 6.70884 4.74217 6.15419 4.91566 5.81096C5.44764 4.7597 6.25177 3.17037 8.05571 3.17037C9.85966 3.17037 10.6638 4.7597 11.1949 5.81096C11.3693 6.15502 11.6505 6.7105 11.8346 6.88377C12.0204 6.7105 12.3016 6.15502 12.4751 5.81096C13.0071 4.75887 13.8112 3.17037 15.616 3.17037C17.42 3.17037 18.2241 4.7597 18.7552 5.81096C18.9295 6.15502 19.2107 6.7105 19.3957 6.88377C19.5816 6.7105 19.8619 6.15502 20.0363 5.81013C20.5682 4.75887 21.3724 3.17037 23.1771 3.17037C24.9819 3.17037 25.7868 4.75887 26.318 5.81013C26.5079 6.1857 26.8261 6.8133 27.007 6.92108C26.9963 6.91445 26.9717 6.90699 26.9585 6.90699L26.9593 9.7366Z\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M39.6255 20.0888H2.27237V29.4114H39.6255V20.0888ZM41.4033 18.2962V31.204H0.494594V18.2962H41.4033Z\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70.6264 1.79259H33.0348V11.1152H70.6264V1.79259ZM72.4042 0V12.9078H31.2571V0H72.4042Z\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M60.4496 24.1C54.4297 24.1 49.5496 28.9801 49.5496 35C49.5496 41.0199 54.4297 45.9 60.4496 45.9C66.4695 45.9 71.3496 41.0199 71.3496 35C71.3496 28.9801 66.4695 24.1 60.4496 24.1ZM47.3496 35C47.3496 27.7651 53.2147 21.9 60.4496 21.9C67.6845 21.9 73.5496 27.7651 73.5496 35C73.5496 42.235 67.6845 48.1 60.4496 48.1C53.2147 48.1 47.3496 42.235 47.3496 35ZM66.5291 30.1917C66.9755 30.6038 67.0033 31.2997 66.5912 31.7461L59.2066 39.7461C58.9984 39.9717 58.7053 40.1 58.3983 40.1C58.0913 40.1 57.7983 39.9717 57.59 39.7461L54.308 36.1906C53.8959 35.7442 53.9238 35.0483 54.3702 34.6362C54.8166 34.2241 55.5125 34.252 55.9246 34.6984L58.3983 37.3783L64.9747 30.2539C65.3867 29.8075 66.0826 29.7797 66.5291 30.1917Z\" />\n</svg>\n");
;// ./src/components/Icon/IconZeroAppliedRedactions/IconZeroAppliedRedactions.tsx



const IconZeroAppliedRedactions = (props) => ((0,jsx_runtime.jsx)(BaseIcon["default"], Object.assign({ icon: zero_applied_redactions_inlineraw }, props)));
/* harmony default export */ const IconZeroAppliedRedactions_IconZeroAppliedRedactions = (IconZeroAppliedRedactions);

;// ./src/components/Icon/IconZeroAppliedRedactions/index.ts

/* harmony default export */ const Icon_IconZeroAppliedRedactions = (IconZeroAppliedRedactions_IconZeroAppliedRedactions);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map